import styled from "styled-components"

import Icon from "../../Icon"

export const DatePickerWrapper = styled.div`
  .react-datepicker {
    overflow-x: hidden;
  }

  .react-datepicker__time-list {
    padding-left: 0;
    padding-right: 0;
  }
`

export const CalendarIcon = styled(Icon)`
  position: relative;
  right: 30px;
  top: 3px;
  pointer-events: none;
`
